









































































import Vue from 'vue';
import { mapGetters } from 'vuex';

// DayJS
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import weekday from 'dayjs/plugin/weekday';
dayjs.extend(weekday);
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat);
dayjs.extend(isoWeek);

// Components
import { getPitchesDays } from '@/utils/pitches';

export default Vue.extend({
	name: 'BaseDetail7',

	props: {
		features: Object,
		state: String,
		step: Number,
		completed: Boolean,
		disabled: Boolean,
	},

	data: () => ({
		form: {
			country: '',
			city: null,
			location: null,
			display_name: null as null | string,
		},
		items: [],
	}),

	computed: {
		...mapGetters(['countries', 'cities', 'locations']),
		location() {
			return this.form.location;
		},

		filteredCities() {
			if (this.form.country) {
				return this.cities.filter((city: HasuraCity) => {
					return city.country_id === this.form.country;
				});
			} else return [];
		},

		filteredLocations() {
			if (this.form.city) {
				return this.locations.filter((location: HasuraLocation) => {
					return location.city_id === this.form.city;
				});
			} else return [];
		},

		formComplete() {
			if (this.form.city && this.form.location) {
				return true;
			} else {
				return false;
			}
		},

		datePickerConfig() {
			return {
				wrap: true, // set wrap to true only when using 'input-group'
				altFormat: 'M j, Y',
				altInput: true,
				dateFormat: 'Y-m-d',
				enable: [],
			};
		},
	},

	methods: {
		handleCancel() {
			this.$emit('setStep', 1);
		},

		handleSave() {
			if (this.form.city && this.form.country && this.form.display_name) {
				this.$emit('saveBaseDetails', { ...this.form });
			}
		},
	},

	watch: {
		city() {
			this.form.location = (this as any).filteredLocations[0].id;
		},
		location: {
			deep: true,
			immediate: true,
			async handler(newVal) {
				if (!newVal) return;
				const pitches: any[] = await this.$store.dispatch('getAllPitchesFromLocation', newVal);
				// @ts-ignore
				this.items = getPitchesDays(pitches);
			},
		},
	},

	mounted() {
		const { country, city, location } = this.features;

		this.form.country = country || this.countries[0].id;
		this.form.city = city || (this as any).filteredCities[0].id;
		this.form.location = location || (this as any).filteredLocations[0].id;
		this.form.display_name = `Man Of The Match Competition (${dayjs(Date()).format('ddd Do MMM, HH:mm')})`;
	},
});
